const state = {
  show: false,
  myIndexes: [],
  screen9: {},
  debugBackground: 'none'
  // debugBackground: 'rgba(13, 22, 53, 1)'
};
const mutations = {
  toggleModal(state) {
    state.show = state.show ? false : true;
  },
  setMyIndexes(state, myIndexes) {
    state.myIndexes = myIndexes;
    if (state.myIndexesClone.length === 0) {
      state.myIndexesClone = Object.assign([], myIndexes);
    }
  },
  setScreen9(state, data){
    state.screen9 = data;
  }
};
export default {
  state,
  mutations
};
